import { Outlet } from 'react-router';

import type { FC } from 'react';

import { AdmittedGate } from 'components/auth/AdmittedGate';

import { AppLayout } from 'containers/AppLayout';

const AppRoute: FC = () => (
  <AdmittedGate>
    <AppLayout>
      <Outlet />
    </AppLayout>
  </AdmittedGate>
);

export {
  AppRoute,
};
